define("checkout/components/checkout/upgrade-button", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "@ember/utils"], function (_exports, _component, _templateFactory, _component2, _object, _service, _tracking, _emberConcurrency, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@embroider/macros",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/utils",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @showButton}}
    <Shared::Ui::Button
      @size={{if @size @size "regular"}}
      @type={{if @type @type "proceed"}}
      @text={{this.text}}
      @additional={{@additional}}
      @onClick={{this.upgrade}}
      ...attributes
    />
  {{/if}}
  
  {{#if this.showTrialPlansModal}}
    <EmberWormhole @to="root-wormhole" @renderInPlace={{this.isTesting}}>
      <Shared::Modal class="" data-test-id="tochange" @close={{this.closeTrialPlansModal}} as |modal|>
        <modal.card @portrait={{false}} class="tPF--modalCard">
          <modal.card-header class="u--p__b__sm">
            <p class="o--modalHeader__title">
              {{!-- <Shared::Ui::Button
                class="u--hide--desktop u--p__0"
                @type="none"
                @onClick={{this.closeTrialPlansModal}}
              >
                {{svg-jar "arrow-left" class="o--icon tCH--text--highlight"}}
                <span class="u--screen-reader">{{t "plans.view_all_plans"}}</span>
              </Shared::Ui::Button> --}}
              {{t "authorization.sign_up_trial.page_title"}}
            </p>
            <p class="u--text--light">
              {{t "authorization.sign_up_trial.sub_title"}}
            </p>
          </modal.card-header>
          <modal.card-body class="u--p__t__0">
            <section class="tPF--planWrapper">
              <div class="tPF--plan tPF--plan—-sm u--m__t__0">
                {{#each this.trialOptInPlans as |plan|}}
                  <Shared::Upgrade::PlanCard
                    @onPlanButtonClick={{fn this.handleSelectedPlan plan.planType}}
                    @plan={{plan}}
                    @showButtonAtBottom={{true}}
                  />
                {{/each}}
              </div>
            </section>
          </modal.card-body>
        </modal.card>
      </Shared::Modal>
    </EmberWormhole>
  {{else if this.showCheckoutModal}}
    <EmberWormhole @to="root-wormhole" @renderInPlace={{this.isTesting}}>
      <Checkout
        @planType={{this.selectedPlan}}
        @onTrialSuccessButton={{this.closeCheckoutModal}}
        @onBackButtonClick={{this.goBackToTrialPlans}}
        @onClose={{this.closeCheckoutModal}}
      />
    </EmberWormhole>
  {{/if}}
  
  */
  {
    "id": "7BZRfAau",
    "block": "[[[41,[30,1],[[[1,\"  \"],[8,[39,1],[[17,2]],[[\"@size\",\"@type\",\"@text\",\"@additional\",\"@onClick\"],[[52,[30,3],[30,3],\"regular\"],[52,[30,4],[30,4],\"proceed\"],[30,0,[\"text\"]],[30,5],[30,0,[\"upgrade\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showTrialPlansModal\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@to\",\"@renderInPlace\"],[\"root-wormhole\",[30,0,[\"isTesting\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,3],[[24,0,\"\"],[24,\"data-test-id\",\"tochange\"]],[[\"@close\"],[[30,0,[\"closeTrialPlansModal\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,6,[\"card\"]],[[24,0,\"tPF--modalCard\"]],[[\"@portrait\"],[false]],[[\"default\"],[[[[1,\"\\n        \"],[8,[30,6,[\"card-header\"]],[[24,0,\"u--p__b__sm\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n\"],[1,\"            \"],[1,[28,[35,4],[\"authorization.sign_up_trial.page_title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"authorization.sign_up_trial.sub_title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,6,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,\"section\"],[14,0,\"tPF--planWrapper\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"tPF--plan tPF--plan—-sm u--m__t__0\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"trialOptInPlans\"]]],null]],null],null,[[[1,\"                \"],[8,[39,7],null,[[\"@onPlanButtonClick\",\"@plan\",\"@showButtonAtBottom\"],[[28,[37,8],[[30,0,[\"handleSelectedPlan\"]],[30,7,[\"planType\"]]],null],[30,7],true]],null],[1,\"\\n\"]],[7]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[6]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCheckoutModal\"]],[[[1,\"  \"],[8,[39,2],null,[[\"@to\",\"@renderInPlace\"],[\"root-wormhole\",[30,0,[\"isTesting\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,9],null,[[\"@planType\",\"@onTrialSuccessButton\",\"@onBackButtonClick\",\"@onClose\"],[[30,0,[\"selectedPlan\"]],[30,0,[\"closeCheckoutModal\"]],[30,0,[\"goBackToTrialPlans\"]],[30,0,[\"closeCheckoutModal\"]]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]]]],[\"@showButton\",\"&attrs\",\"@size\",\"@type\",\"@additional\",\"modal\",\"plan\"],false,[\"if\",\"shared/ui/button\",\"ember-wormhole\",\"shared/modal\",\"t\",\"each\",\"-track-array\",\"shared/upgrade/plan-card\",\"fn\",\"checkout\"]]",
    "moduleName": "checkout/components/checkout/upgrade-button.hbs",
    "isStrictMode": false
  });
  /**
   * @module Components
   */


  let UpgradeButton = (_class = class UpgradeButton extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "plans", _descriptor2, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);

      _initializerDefineProperty(this, "showUpgradeModal", _descriptor4, this);

      _initializerDefineProperty(this, "selectedPlan", _descriptor5, this);

      _initializerDefineProperty(this, "trialOptInPlans", _descriptor6, this);

      this.loadTrialPlans.perform();
    }

    get isTesting() {
      return false;
    }

    get showCheckoutModal() {
      return this.showUpgradeModal && ['starter', 'growth', 'advanced'].includes(this.selectedPlan);
    } // Note: Trial Plans modal shows when no plan is selected.


    get showTrialPlansModal() {
      return this.showUpgradeModal && (0, _utils.isEmpty)(this.selectedPlan);
    }

    get text() {
      return this.intl.t('shared_phrases.upgrade_trial');
    }

    goBackToTrialPlans() {
      // Note: showTrialPlansModal getter depends on selectedPlan being empty.
      this.selectedPlan = null;
    }

    handleSelectedPlan(planName) {
      this.selectedPlan = planName;
    }

    upgrade() {
      this.showUpgradeModal = true;
    }

    *loadTrialPlans() {
      this.trialOptInPlans = yield this.plans.trialOptInPlans();
    }

    closeTrialPlansModal() {
      this.showUpgradeModal = false;
    }

    closeCheckoutModal() {
      this.selectedPlan = null;
      this.showUpgradeModal = false;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showUpgradeModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedPlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "trialOptInPlans", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "goBackToTrialPlans", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goBackToTrialPlans"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSelectedPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSelectedPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "upgrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "upgrade"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadTrialPlans", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "loadTrialPlans"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTrialPlansModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTrialPlansModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCheckoutModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCheckoutModal"), _class.prototype)), _class);
  _exports.default = UpgradeButton;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeButton);
});